<template>
    <div>
        <header>
            <div class="header-title">
                <div style="display: flex; align-items: center;">
                    <p>自然人基本信息</p>
                    <span class="basic-top-btn" @click="goChangeList">查看历史变更记录</span>
                </div>
                <div>

                </div>
            </div>
        </header>
        <div class="container">
            <div class="card-item">
                <div class="card-title" style="display: flex;justify-content: space-between;align-items: center;">
                    <span>基本信息</span>
                </div>
                <div class="card-content">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleFormMain" label-width="170px">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="姓名 : " prop="manName" size="small">
                                    <el-input v-model="ruleForm.manName" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系电话 : " prop="contractTel" size="small">
                                    <el-input v-model="ruleForm.contractTel" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="身份证件类型 : " prop="idType" size="small">
                                    <el-select v-model="ruleForm.idType" placeholder="请选择" clearable>
                                        <el-option v-for="(item,index) in orgCertTypeList"
                                                   :key="index"
                                                   :label="item.text"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="身份证件号码 : " prop="idCard" size="small">
                                    <el-input v-model="ruleForm.idCard" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="身份证件失效日期 : " prop="idExpirationTime" size="small">
                                    <el-date-picker
                                            clearable
                                            v-model="ruleForm.idExpirationTime"
                                            type="date"
                                            placeholder="请选择日期时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="工作单位 : " prop="workPlace" size="small">
                                    <el-input v-model="ruleForm.workPlace" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="居住地址 : " prop="linkAddr" size="small">
                                    <div style="display: flex">
                                        <el-cascader
                                                size="small"
                                                :options="options"
                                                v-model="ruleForm.linkAddr"
                                                @change="personRegionHandleChange">
                                        </el-cascader>
                                        <el-input style="margin-left: 10px" placeholder="请输入街道 小区 门牌号等信息"
                                                  v-model="ruleForm.detailAddress"
                                                  clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="保证金银行账号 : " prop="securityAmountBankNumber" size="small">
                                    <el-input v-model="ruleForm.securityAmountBankNumber" placeholder="请输入"
                                              clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="保证金银行账号开户行 : " prop="bankName" size="small">
                                    <el-input v-model="ruleForm.bankName" placeholder="请输入" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="交易主体角色类型 : " prop="traddingMainTypes" size="small">
                                    <el-checkbox-group v-model="ruleForm.traddingMainTypesArr">
                                        <div class="all-deal-type">
                                            <div class="item-deal-type">
                                                <div class="item-deal-title">国有产权交易</div>
                                                <div class="item-deal-content">
                                                    <el-row>
                                                        <el-col>
                                                            <el-checkbox label="1515390002424019">竞买人</el-checkbox>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                            </div>
                                            <div class="item-deal-type">
                                                <div class="item-deal-title">国土交易</div>
                                                <div class="item-deal-content">
                                                    <el-row>
                                                        <el-col>
                                                            <el-checkbox label="1515390002424020">竞买人</el-checkbox>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                            </div>
                                        </div>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <el-form-item label="身份证件信息 : " prop="fileList1" size="small">
                                    <docUploadForm
                                            v-if="fileFlag"
                                            :type="type"
                                            :index="0"
                                            :docItem.sync="ruleForm.attachmentParamList[0]"
                                            :fileLists.sync="ruleForm.fileList1"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="其他附件信息 : " prop="fileList2" size="small">
                                    <docUploadForm
                                            v-if="fileFlag"
                                            :type="type"
                                            :index="1"
                                            :docItem.sync="ruleForm.attachmentParamList[1]"
                                            :fileLists.sync="ruleForm.fileList2"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="bottom-btn">
            <el-button>返回</el-button>
            <el-button type="primary" @click="preservation('ruleFormMain')">保存</el-button>
            <el-button type="primary" @click="personSubmit()">提交</el-button>
        </div>
    </div>
</template>
<script>
    import {regionData} from 'element-china-area-data'
    import {mapState} from "vuex";

    export default {
        props:{
            exitFlag:{
                type: Boolean
            },
            viewFlag:{
                type: Boolean
            }
        },
        data() {
            return {
                id:'',
                fileFlag: false,
                type: 'ent_base_info',
                ruleForm: {
                    id: '',
                    manName: '',
                    contractTel: '',
                    idType: '',
                    idCard: '',
                    idExpirationTime: '',
                    workPlace: '',
                    linkAddr: [],
                    securityAmountBankNumber: '',
                    bankName: '',
                    traddingMainTypes: '',
                    traddingMainTypesArr: [],
                    detailAddress: '',
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }, {//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList1: [],
                    fileList2: [],
                },
                rules: {
                    manName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                    ],
                    contractTel: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                    ],
                    idType: [
                        {required: true, message: '请选择身份证件类型', trigger: 'change'},
                    ],
                    idCard: [
                        {required: true, message: '请输入身份证件号码', trigger: 'blur'},
                    ],
                    idExpirationTime: [
                        {required: true, message: '请选择身份证件失效日期', trigger: 'change'},
                    ],
                    workPlace: [
                        {required: true, message: '请输入工作单位', trigger: 'blur'},
                    ],
                    linkAddr: [
                        {required: true, message: '请输入居住地址', trigger: 'blur'},
                    ],
                    securityAmountBankNumber: [
                        {required: true, message: '请输入保证金银行账号', trigger: 'blur'},
                    ],
                    bankName: [
                        {required: true, message: '请输入保证金银行账号开户行', trigger: 'blur'},
                    ],
                    traddingMainTypesArr: [
                        {required: true, message: '请选择交易主体角色类型', trigger: 'change'},
                    ],
                    fileList1: [
                        {required: true, message: '请上传身份证件信息', trigger: 'change'},
                    ],
                    fileList2: [
                        {required: true, message: '请上传附件信息', trigger: 'change'},
                    ],
                },
                options: regionData,
            }
        },
        created() {
            this.getRouterQuery();
            this.getBasicInfoMsg();
            this.$store.dispatch('dataDictionary/getOrgCertTypeList');//获取证件类型
        },
        activated() {
            this.getRouterQuery();
            this.getBasicInfoMsg();
            this.$store.dispatch('dataDictionary/getOrgCertTypeList');//获取证件类型
        },
        computed: {
            ...mapState({
                orgCertTypeList: (state) => state.dataDictionary.orgCertTypeList,
            })
        },
        methods: {
            getRouterQuery(){
                this.id = this.$route.query.id;
            },
            getBasicInfoMsg() { //获取基本信息
                this.$http.post('/change/hpersonbaseinfo/get?id=' + this.entId).then((res) => {
                    if (res.data.code == 1) {
                        this.ruleForm.manName = res.data.data.manName;
                        this.ruleForm.contractTel = res.data.data.contractTel;
                        this.ruleForm.idType = res.data.data.idType;
                        this.ruleForm.idCard = res.data.data.idCard;
                        this.ruleForm.idExpirationTime = res.data.data.idExpirationTime.replace(/-/g,'/');
                        this.ruleForm.workPlace = res.data.data.workPlace;
                        this.ruleForm.linkAddr = res.data.data.linkAddr;
                        this.ruleForm.securityAmountBankNumber = res.data.data.securityAmountBankNumber;
                        this.ruleForm.bankName = res.data.data.bankName;
                        this.ruleForm.detailAddress = res.data.data.detailAddress;
                        this.ruleForm.traddingMainTypesArr = res.data.data.traddingMainTypes ? res.data.data.traddingMainTypes.split(',') : [];
                        if (res.data.data.attachmentParamList.length > 0) {
                            this.ruleForm.attachmentParamList = res.data.data.attachmentParamList;
                        }
                        this.fileFlag = true;
                    }
                })
            },
            //联系人信息地区三级联动点击事件
            personRegionHandleChange(value) {
                this.ruleForm.linkAddr = value[value.length - 1];
            },
            // 保存
            preservation(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ruleForm.id = this.entId;
                        let roleTypeStr = this.ruleForm.traddingMainTypesArr;
                        this.ruleForm.traddingMainTypes = roleTypeStr.join(',');
                        this.$http.post('/change/hpersonbaseinfo/save', this.ruleForm).then((res) => {
                            if(res.data.code == 1){
                                this.$emit('update:exitFlag',false);
                                this.$emit('update:viewFlag',true);
                                this.$notify({
                                    title: '基本信息保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    title: '基本信息保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                })
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            //提交
            personSubmit() {
                this.ruleForm.id = this.entId;
                let roleTypeStr = this.ruleForm.traddingMainTypesArr;
                this.ruleForm.traddingMainTypes = roleTypeStr.join(',');
                this.$http.post('/change/hpersonbaseinfo/submit',this.ruleForm).then(res => {
                    if (res.data.code == 1) {
                        this.$notify({
                            title: '基本信息提交',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    } else {
                        this.$notify({
                            title: '基本信息提交',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })
            },
            goChangeList(){
                this.$router.push({path:'/changeHistory-change-list'})
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-input {
        width: 324px;
    }

    /deep/ .el-textarea__inner {
        width: 658px;
        height: 156px;
    }
    /deep/ .el-input--small .el-input__inner{
        width: 324px;
    }
    header {
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title {
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
                padding-top: 20px;
            }
            .basic-top-btn {
                width: 112px;
                height: 22px;
                font-size: 14px;
                color: #1890FF;
                line-height: 22px;
                margin-left: 12px;
                margin-top: 2px;
                text-align: center;
                cursor:pointer;
            }
        }
    }

    .container {
        margin: 20px;
        .all-deal-type {
            display: flex;

            .item-deal-type {
                width: 480px;
                border: 1px solid #EEEEEE;
                border-radius: 4px 4px 0px 0px;

                .item-deal-title {
                    width: 100%;
                    height: 45px;
                    background: #FAFAFA;
                    border-radius: 2px 2px 0px 0px;
                    border-bottom: 1px solid #EEEEEE;
                    text-align: center;
                    line-height: 45px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }

                .item-deal-content {
                    padding: 15px;
                    display: flex;
                    justify-content: center;
                }
            }

            .item-deal-type:nth-last-child(1) {
                border-left: 0;
            }
        }
    }
</style>